import {CommonModule, JsonPipe, DatePipe} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {DataTableService} from '../../../core/services/data-table.service';
import {SideBarComponent} from '../../../shared/components/side-bar/side-bar.component';
import {TableActionDirective} from '../../../shared/components/table/table-action.directive';
import {TableCellDirective} from '../../../shared/components/table/table-cell.directive';
import {TableComponent} from '../../../shared/components/table/table.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {SideBarDoubleComponent} from '../../../shared/components/side-bar-double/side-bar-double.component';
import {First3Pipe} from '../../../core/pipes/first3.pipe';
import {FilterIndicatorsBarComponent} from '../register/filter-indicators-bar/filter-indicators-bar.component';
import {RegisterHeaderComponent} from '../register/register-header/register-header.component';
import {UserService} from '../../apiModule1';
import {UsersTableService} from './columns-index.service';
import {DialogComponent} from './dialog/dialog.component';
import {FilterDialogComponent} from './filter-dialog/filter-dialog.component';
import {CURRENT_ENTITY_TOKEN, DataService, IndexEntityComponent} from '../index-entity/index-entity.component';
import {CapitalizePipe} from '../../../core/pipes/capitalize.pipe';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';


@Component({
  selector: 'pas-users',
  standalone: true,
  imports: [
    CommonModule,
    TableComponent,
    TableCellDirective,
    TableActionDirective,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuTrigger,
    RegisterHeaderComponent,
    MatSidenavModule,
    MatDatepickerModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    SideBarDoubleComponent,
    DatePipe,
    FilterIndicatorsBarComponent,
    CapitalizePipe,
    MatProgressSpinnerModule
  ],
  templateUrl: '../index-entity/index-entity.component.html',
  styleUrls: ['../index-entity/index-entity.component.scss', './users.component.scss'],
  providers: [
    {provide: DataTableService, useClass: UsersTableService},
    {provide: CURRENT_ENTITY_TOKEN, useValue: 'users'},
    {provide: DataService, useClass: UserService},
  ]
})
export class UsersComponent extends IndexEntityComponent {

  protected override dialogComponent = DialogComponent;
  protected override filterDialogComponent = FilterDialogComponent;

  constructor(
    public override dataTableService: DataTableService,
    @Inject(DataService) public override dataService: any,
    @Inject(CURRENT_ENTITY_TOKEN) public override currentEntity: string) {
    super(dataTableService, dataService, currentEntity);
  }


}
